export default {
  css: {
  	ext: 'css',
    mode: 'text/css',
  },
  html: {
  	ext: 'html',
    mode: 'htmlmixed',
  },
  javascript: { 
  	ext: 'js',
    mode: 'text/javascript',
  },
  json: {
    ext: 'json',
    mode: 'application/json',
  },
  less: {
    ext: 'less',
    mode: 'text/x-less',
  },
  scss: {
    ext: 'scss',
    mode: 'text/x-scss',
  },
  typescript: {
    ext: 'ts',
    mode: 'text/typescript',
  },
  vue: {
    ext: 'vue',
    mode: 'text/x-vue',
  },
};
